// ========================================
// Formation Calendar View
// Similar to Google Sheets workflow
// ========================================

const FormationCalendar = {
    currentFormationId: null,
    currentStartMonth: new Date(),
    subjectColors: {},

    render() {
        const formations = DataManager.getFormations();

        if (formations.length === 0) {
            return `
                <div class="card">
                    <p style="text-align: center; color: var(--text-secondary);">
                        No hay formaciones creadas. 
                        <a href="/formaciones" ${UIEvents.attr("click", function(event,captured){App.navigate('formaciones');}, [])}>Crear una formación</a>
                    </p>
                </div>
            `;
        }

        // Set default formation if none selected
        if (!this.currentFormationId && formations.length > 0) {
            this.currentFormationId = formations[0].id;
        }

        const formation = DataManager.getFormation(this.currentFormationId);
        if (!formation) {
            this.currentFormationId = formations[0].id;
        }

        return `
            <div class="formation-calendar-container">
                ${this.renderHeader(formations)}
                ${this.renderCalendarsGrid()}
                ${this.renderColorLegend()}
                ${this.renderSessionsTable()}
            </div>
        `;
    },

    renderHeader(formations) {
        const currentDate = new Date(this.currentStartMonth);
        const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

        const startMonth = monthNames[currentDate.getMonth()];
        const endDate = new Date(currentDate);
        endDate.setMonth(endDate.getMonth() + 3);
        const endMonth = monthNames[endDate.getMonth()];

        return `
            <div class="formation-header">
                ${this.renderTabs(formations)}
                
                <div class="formation-controls-row">
                    <div style="flex: 1;"></div> <!-- Spacer -->
                    
                    <div class="month-navigation">
                        <button class="btn btn-secondary" ${UIEvents.attr("click", function(event,captured){FormationCalendar.navigateMonths(-4);}, [])}>
                            <i class="fas fa-chevron-left"></i> Anterior
                        </button>
                        <span style="font-weight: 600; min-width: 200px; text-align: center;">
                            ${startMonth} - ${endMonth} ${currentDate.getFullYear()}
                        </span>
                        <button class="btn btn-secondary" ${UIEvents.attr("click", function(event,captured){FormationCalendar.navigateMonths(4);}, [])}>
                            Siguiente <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        `;
    },

    renderTabs(formations) {
        return `
            <div class="formation-tabs-container">
                <div class="formation-tabs" id="formation-tabs">
                    ${formations.map(f => `
                        <div class="formation-tab-item ${f.id === this.currentFormationId ? 'active' : ''}" 
                             draggable="true" 
                             data-id="${Utils.sanitizeHTML(f.id)}"
                             ${UIEvents.attr("click", function(event,captured){FormationCalendar.changeFormation(String(captured[0]));}, [f.id])}>
                            <span class="drag-handle"><i class="fas fa-grip-vertical"></i></span>
                            <span>${Utils.sanitizeHTML(f.name)}</span>
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
    },

    attachEventListeners() {
        const tabsContainer = document.getElementById('formation-tabs');
        if (!tabsContainer) return;

        const tabs = tabsContainer.querySelectorAll('.formation-tab-item');
        tabs.forEach(tab => {
            tab.addEventListener('dragstart', this.handleDragStart.bind(this));
            tab.addEventListener('dragover', this.handleDragOver.bind(this));
            tab.addEventListener('drop', this.handleDrop.bind(this));
            tab.addEventListener('dragenter', this.handleDragEnter.bind(this));
            tab.addEventListener('dragleave', this.handleDragLeave.bind(this));
        });
    },

    handleDragStart(e) {
        e.dataTransfer.setData('text/plain', e.currentTarget.dataset.id);
        e.currentTarget.classList.add('dragging');
        e.dataTransfer.effectAllowed = 'move';
    },

    handleDragOver(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        return false;
    },

    handleDragEnter(e) {
        e.preventDefault();
        e.currentTarget.classList.add('drag-over');
    },

    handleDragLeave(e) {
        e.currentTarget.classList.remove('drag-over');
    },

    handleDrop(e) {
        e.stopPropagation();
        e.preventDefault();

        const dropTarget = e.currentTarget;
        dropTarget.classList.remove('drag-over');

        const draggedId = e.dataTransfer.getData('text/plain');
        const targetId = dropTarget.dataset.id;

        // Remove dragging class from all tabs
        document.querySelectorAll('.formation-tab-item').forEach(tab => {
            tab.classList.remove('dragging');
        });

        if (draggedId !== targetId) {
            this.reorderFormations(draggedId, targetId);
        }

        return false;
    },

    reorderFormations(draggedId, targetId) {
        const formations = DataManager.getFormations();
        // Note: getFormations returns sorted array

        const draggedIndex = formations.findIndex(f => f.id === draggedId);
        const targetIndex = formations.findIndex(f => f.id === targetId);

        if (draggedIndex === -1 || targetIndex === -1) return;

        // Move element
        const [movedFormation] = formations.splice(draggedIndex, 1);
        formations.splice(targetIndex, 0, movedFormation);

        // Update orders
        const newOrderIds = formations.map(f => f.id);
        FormationService.updateFormationsOrder(newOrderIds);

        // Refresh view
        App.refresh();
        Utils.showToast('Orden actualizado', 'success');
    },

    renderCalendarsGrid() {
        const startDate = new Date(this.currentStartMonth);
        if (typeof FileStorage !== 'undefined' && FileStorage.needClasses) {
            FileStorage.needClasses(startDate, new Date(startDate.getFullYear(), startDate.getMonth() + 4, 0), () => App.refresh());
        }
        let html = '<div class="calendars-grid">';

        for (let i = 0; i < 4; i++) {
            const month = new Date(startDate);
            month.setMonth(startDate.getMonth() + i);
            html += this.renderMonthCalendar(month.getFullYear(), month.getMonth());
        }

        html += '</div>';
        return html;
    },

    renderMonthCalendar(year, month) {
        const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        let startDayOfWeek = firstDay.getDay();

        // Adjust for Monday start (0 = Monday, 6 = Sunday)
        startDayOfWeek = startDayOfWeek === 0 ? 6 : startDayOfWeek - 1;

        let html = `
            <div class="month-calendar">
                <h3>${monthNames[month]} ${year}</h3>
                <div class="calendar-grid">
        `;

        // Headers
        ['L', 'M', 'X', 'J', 'V', 'S', 'D'].forEach(day => {
            html += `<div class="calendar-header">${day}</div>`;
        });

        // Empty cells before first day
        for (let i = 0; i < startDayOfWeek; i++) {
            html += '<div class="calendar-day empty"></div>';
        }

        // Days of month
        for (let day = 1; day <= daysInMonth; day++) {
            const dayClasses = this.getClassesForDay(year, month, day);
            const colors = dayClasses.map(cls => this.getColorForSubject(cls.subjectId));
            const background = this.getDayBackground(colors);

            const classNames = ['calendar-day'];
            if (colors.length > 0) classNames.push('has-classes');

            // Check if it's today
            const today = new Date();
            if (year === today.getFullYear() && month === today.getMonth() && day === today.getDate()) {
                classNames.push('today');
            }

            html += `
                <div class="${classNames.join(' ')}"
                     style="background: ${background}"
                     data-day="${day}" data-month="${month}" data-year="${year}"
                     ${UIEvents.attr("click", function(event,captured){FormationCalendar.showDayDetails(captured[0],captured[1],captured[2]);}, [year, month, day])}
                     title="${dayClasses.length} clase${dayClasses.length !== 1 ? 's' : ''}">
                    ${day}
                </div>
            `;
        }

        html += '</div></div>';
        return html;
    },

    getClassesForDay(year, month, day) {
        const classes = DataManager.getClassesByFormation(this.currentFormationId);
        const targetDate = new Date(year, month, day);
        const targetDayOfWeek = targetDate.getDay();

        return classes.filter(cls => {
            // Check if day of week matches
            if (cls.dayOfWeek !== targetDayOfWeek) {
                return false;
            }

            // Check if the date is within the class date range
            const classStartDate = new Date(cls.startDate);
            classStartDate.setHours(0, 0, 0, 0);

            const classEndDate = cls.endDate ? new Date(cls.endDate) : null;
            if (classEndDate) {
                classEndDate.setHours(23, 59, 59, 999);
            }

            // Normalize target date for comparison
            const normalizedTargetDate = new Date(targetDate);
            normalizedTargetDate.setHours(12, 0, 0, 0);

            // Check if target date is within range
            if (normalizedTargetDate < classStartDate) {
                return false;
            }

            if (classEndDate && normalizedTargetDate > classEndDate) {
                return false;
            }

            return true;
        });
    },

    getDayBackground(colors) {
        if (colors.length === 0) return 'transparent';
        if (colors.length === 1) return colors[0];

        // Multiple classes - create gradient
        const step = 100 / colors.length;
        const gradient = colors.map((color, i) =>
            `${color} ${i * step}% ${(i + 1) * step}%`
        ).join(', ');

        return `linear-gradient(135deg, ${gradient})`;
    },

    getColorForSubject(subjectId) {
        if (!this.subjectColors[subjectId]) {
            // Get the subject and use its saved color if available
            const subject = DataManager.getSubject(subjectId);
            if (subject && subject.color) {
                this.subjectColors[subjectId] = subject.color;
                return subject.color;
            }

            // Fallback to auto-generated color
            const colors = [
                '#FFD700', '#FF8C00', '#9370DB', '#4169E1', '#32CD32', '#FF6347',
                '#FF69B4', '#20B2AA', '#DDA0DD', '#F0E68C', '#87CEEB', '#FA8072'
            ];

            const usedColors = Object.values(this.subjectColors);
            const availableColors = colors.filter(c => !usedColors.includes(c));

            this.subjectColors[subjectId] = availableColors.length > 0
                ? availableColors[0]
                : colors[Object.keys(this.subjectColors).length % colors.length];
        }

        return this.subjectColors[subjectId];
    },

    renderColorLegend() {
        const subjects = DataManager.getSubjectsByFormation(this.currentFormationId);

        if (subjects.length === 0) {
            return '';
        }

        let html = `
            <div class="color-legend">
                <h4 style="width: 100%; margin-bottom: 0.5rem;">Leyenda de Asignaturas</h4>
        `;

        subjects.forEach(subject => {
            const color = this.getColorForSubject(subject.id);
            const professor = DataManager.getProfessor(subject.professorId);
            const professorName = professor ? `${professor.firstName} ${professor.lastName}` : 'Sin profesor';

            html += `
                <div class="legend-item">
                    <div class="legend-color" style="background: ${color}"></div>
                    <span><strong>${Utils.sanitizeHTML(subject.name)}</strong> - ${Utils.sanitizeHTML(professorName)}</span>
                </div>
            `;
        });

        html += '</div>';
        return html;
    },

    renderSessionsTable() {
        const classes = DataManager.getClassesByFormation(this.currentFormationId);

        if (classes.length === 0) {
            return `
                <div class="sessions-table-container">
                    <h3>Sesiones de la Formación</h3>
                    <p style="text-align: center; color: var(--text-secondary); padding: 2rem;">
                        No hay clases programadas para esta formación
                    </p>
                </div>
            `;
        }

        const grouped = this.groupClassesBySchedule(classes);

        let html = `
            <div class="sessions-table-container">
                <h3>Sesiones de la Formación</h3>
                <table class="sessions-table">
                    <thead>
                        <tr>
                            <th>Horario</th>
                            <th>Asignatura - Profesor</th>
                            <th>Aula</th>
                            <th>Observaciones</th>
                        </tr>
                    </thead>
                    <tbody>
        `;

        grouped.forEach(group => {
            const subject = DataManager.getSubject(group.subjectId);
            const professor = DataManager.getProfessor(subject.professorId);
            const color = this.getColorForSubject(group.subjectId);

            html += `
                <tr style="border-left: 4px solid ${color}">
                    <td>
                        <strong>${group.timeRange}</strong><br>
                        <small style="color: var(--text-secondary);">${group.daysText}</small>
                    </td>
                    <td>
                        <strong>${Utils.sanitizeHTML(subject.name)}</strong><br>
                        <small style="color: var(--text-secondary);">${professor ? `${professor.firstName} ${professor.lastName}` : 'Sin profesor'}</small>
                    </td>
                    <td>${group.classroom || '-'}</td>
                    <td style="font-size: 0.875rem; color: var(--text-secondary);">
                        ${group.observations || '-'}
                    </td>
                </tr>
            `;
        });

        html += '</tbody></table></div>';
        return html;
    },

    groupClassesBySchedule(classes) {
        const groups = {};

        classes.forEach(cls => {
            const key = `${cls.subjectId}-${cls.startTime}-${cls.endTime}`;

            if (!groups[key]) {
                groups[key] = {
                    subjectId: cls.subjectId,
                    startTime: cls.startTime,
                    endTime: cls.endTime,
                    days: [],
                    classroom: cls.classroom,
                    observations: cls.observations || ''
                };
            }

            if (!groups[key].days.includes(cls.dayOfWeek)) {
                groups[key].days.push(cls.dayOfWeek);
            }
        });

        return Object.values(groups).map(group => {
            group.days.sort((a, b) => a - b);
            group.timeRange = `${group.startTime} - ${group.endTime}`;
            group.daysText = this.formatDaysRange(group.days);
            return group;
        });
    },

    formatDaysRange(days) {
        if (days.length === 0) return '';
        if (days.length === 1) return Utils.getDayName(days[0]);

        // Check if consecutive
        const isConsecutive = days.every((day, i) =>
            i === 0 || day === days[i - 1] + 1 || (days[i - 1] === 0 && day === 1)
        );

        if (isConsecutive && days.length > 2) {
            return `${Utils.getDayName(days[0])} a ${Utils.getDayName(days[days.length - 1])}`;
        }

        return days.map(d => Utils.getDayName(d)).join(', ');
    },

    showDayDetails(year, month, day) {
        const date = new Date(year, month, day);
        const dayClasses = this.getClassesForDay(year, month, day);

        const dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

        let content = `
            <h3>${dayNames[date.getDay()]} ${day} de ${monthNames[month]} ${year}</h3>
        `;

        if (dayClasses.length === 0) {
            content += '<p style="color: var(--text-secondary);">No hay clases programadas este día</p>';
        } else {
            content += '<div class="day-classes-list">';

            dayClasses.forEach(cls => {
                const subject = DataManager.getSubject(cls.subjectId);
                const professor = DataManager.getProfessor(subject.professorId);
                const color = this.getColorForSubject(cls.subjectId);

                content += `
                    <div class="day-class-item" style="border-left: 4px solid ${color}; padding: 1rem; margin-bottom: 1rem; background: var(--bg-card); border-radius: 8px;">
                        <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 0.5rem;">
                            <strong style="font-size: 1.125rem;">${cls.startTime} - ${cls.endTime}</strong>
                            ${cls.classroom ? `<span class="badge badge-primary">${cls.classroom}</span>` : ''}
                        </div>
                        <p style="margin: 0.5rem 0; font-size: 1rem;"><strong>${Utils.sanitizeHTML(subject.name)}</strong></p>
                        ${professor ? `
                            <p style="margin: 0; color: var(--text-secondary); font-size: 0.875rem;">
                                <i class="fas fa-chalkboard-teacher"></i> ${Utils.sanitizeHTML(professor.firstName)} ${Utils.sanitizeHTML(professor.lastName)}
                            </p>
                        ` : `
                            <p style="margin: 0; color: var(--text-secondary); font-size: 0.875rem;">
                                <i class="fas fa-user-slash"></i> Sin profesor asignado
                            </p>
                        `}
                    </div>
                `;
            });

            content += '</div>';
        }

        Utils.openModal('Clases del Día', content);
    },

    changeFormation(formationId) {
        this.currentFormationId = formationId;
        this.subjectColors = {}; // Reset colors for new formation
        App.refresh();
    },

    navigateMonths(offset) {
        const current = new Date(this.currentStartMonth);
        current.setMonth(current.getMonth() + offset);
        this.currentStartMonth = current;
        App.refresh();
    }
};

// Make FormationCalendar globally available
window.FormationCalendar = FormationCalendar;
